const onToggleLanguage = (currentlySelectedLanguages, selectedLanguage) => {
  const index = currentlySelectedLanguages.indexOf(selectedLanguage);
  return index > -1
    ? [
        ...currentlySelectedLanguages.slice(0, index),
        ...currentlySelectedLanguages.slice(index + 1),
      ]
    : [...currentlySelectedLanguages, selectedLanguage];
};

export default { onToggleLanguage };
